export default __webpack_public_path__ + "static/media/notification-ring.4378e9fa.mp3";